import { render, staticRenderFns } from "./ApproveEnvelopeModal.vue?vue&type=template&id=5043ad2e&lang=pug"
import script from "./ApproveEnvelopeModal.vue?vue&type=script&lang=js"
export * from "./ApproveEnvelopeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports